<template>
  <div class="xcard">
        <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
    <form @submit.prevent="validarCampos" style="margin-top:0;" novalidate>
      <h3 class="text-center"> Asignar aula a los modulos del programa </h3>
      
      <div class="xcard" style="margin-bottom:16px">
        <p> <b>Programa:</b> {{getPrograma()}} </p>
        <p> <b>Sede:</b> {{getSede()}} </p>
        <p> <b>Gestion:</b> {{getGestion()}} </p>
      </div>
      <div class="row">
        <div class="col-sm-2"> <b>Modulo:</b> </div>
        <div class="col-sm-10"> <AModulosPrograma :model="modulo" :programa="programa"/> </div>
      </div>
      <div class="row">
        <div class="col-sm-2"> <b>Sede:</b> </div>
        <div class="col-sm-10"> <Sedes :model="sede"/> </div>
      </div>
      <div class="row">
        <div class="col-sm-2"> <b>Aula:</b> </div>
        <div class="col-sm-10"> <Aulas :model="aula" :sede="sede"/> </div>
      </div>
      <div class="row">
        <div class="col-sm-2"> <b>Dias:</b> </div>
        <div class="col-sm-10"> <ASemanasAula :model="semana"/> </div>
      </div>

      <p class="text-center text-danger"> {{msg}} </p>
      <Alertas ref="alertar" />

      <button class="btn btn-azul center-block" type="submit"> Asignar aula a este modulo </button>
    </form>
  </div>
</template>

<script>
import AModulosPrograma from '@/components/AModulosPrograma'
import ASemanasAula from '@/components/ASemanasAula'
import Sedes from '@/components/ASedes'
import Alertas from '@/components/AAlertas'
import Aulas from '@/components/AAulas'
import gql from 'graphql-tag'
export default {
  data(){
    return{
      msg: '',
      programa:{},
      modulo: {idmodulo:{}},
      sede: {idsede:{}},
      aula:{idaula:{}},
      semana: {idsemana:[]},
    }
  },
  components:{ Sedes,Aulas,AModulosPrograma,ASemanasAula,Alertas },
  watch:{
    'modulo.idmodulo': function(){
      this.msg = '';
      this.aula = {idaula:{}};
    }
  },
  methods:{
    getPrograma(){
      if( this.programa == null ) return "No hay programa seleccionado.";
      if( this.programa.postgrado == null ) return "No existe programa seleccionado.";
      var post = '';
      post = this.programa.postgrado.nombre;
      return post;
    },
    getSede(){
      if( this.programa == null ) return "-";
      return this.programa.sede.nombre;
    },
    getGestion(){
      if( this.programa == null ) return "-";
      return this.programa.gestion;
    },
    validarCampos(){
      this.msg = '';
      if( this.programa == null ){
        this.msg = 'No hay un programa seleccionado.';
        return;
      }
      if( this.modulo.idmodulo.idmodulo == null ){
        this.msg = 'No hay modulo seleccionado.';
        return;
      }
      if( this.aula.idaula.id == null ){
        this.msg = 'No hay un aula seleccionado.';
        return;
      }
      if( this.semana.idsemana.length == 0 ){
        this.msg = 'No hay dias seleccionados.';
        return;
      }

      var idprograma = this.programa.id;
      var idmodulo = this.modulo.idmodulo.idmodulo;
      var idaula = this.aula.idaula.id;
      var sem = {};
      this.semana.idsemana.forEach( function(e){
        sem[e.id] = true;
      });
      var input = { idprograma:idprograma,idmodulo:idmodulo,idaula:idaula,semana:sem }


      var sql = gql`mutation{ asignarAula(input:${window.stringifyObject(input)}){ok,errors{message}} }`;
      window.console.log( sql );
      var vue = this;

      this.$apollo.mutate({
          mutation: sql,
      }).then((data) => {
          if(data.data.asignarAula.ok){
              vue.$refs.alertar.success();
          }else{
              var errores = JSON.stringify(data.data.asignarAula.errors);
              var obj = JSON.parse( errores );
              var vals = '';
              obj.forEach(function(k){ vals += Object.values(k)+"-\n\t"; });
              //vue.msg = vals;
              vue.activo = true;
              vue.$refs.alertar.invalido( vals );
          }
          
          window.console.log(data);
      }).catch((error) => {
          vue.$refs.alertar.invalido();
          this.activo = true;
          window.console.error(error);
          //vue.msg = error;
          vue.$refs.alertar.invalido( error );
      })



    }
  },
  mounted(){
    var xp = sessionStorage.xprograma;
    if( xp != null ) this.programa = JSON.parse( xp );
    window.console.log( "--------------- asigaulas:::",window.stringifyObject(this.programa) )
  }
}
</script>